import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Layout from '../components/Layout'
import PageContent from '../components/PageContent'


export default function IndexPage() {

  const data = useStaticQuery(graphql`
        query HomePage {
          wpPage(title: {eq: "Home"}) {
            title
            content
            pageOptions {
              subtitle
            }
          }
        }
      `)

  return (
    
        <Layout>
          <PageContent title={data.wpPage.title} subtitle={data.wpPage.pageOptions.subtitle} content={data.wpPage.content} />
        </Layout>

  )
}

